var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.homeContent && _vm.showHomeContent)?_c(_vm.homeContent,{tag:"component",attrs:{"visible-key":"showHomeContent","parent-target":_vm._self},on:{"reload":_vm.$reloadHandle}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }